import { ref, string } from "yup";
import { signupValidationSchema, PASSWORD_RULE } from "./signupValidationSchema";

export const changePasswordValidationSchema = signupValidationSchema.pick(["password"]).shape({
    new_password: PASSWORD_RULE,
    password_confirm: string().oneOf([ref("new_password")], "Passwords must match"),
});
